import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationsInItalian from '../locales/it/translation.json';
import translationsInEng from '../locales/en/translation.json';

const resources = {
    it: {
        translation: translationsInItalian
    },
    en: {
        translation: translationsInEng
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "it",
        debug: true,
        fallbackLng: "it",
        interpolation: {
            escapeValue: false
        },
        ns: "translation",
        defaultNS: "translation"
    });

export default i18n;